import React from 'react';
import { Button as InternalButton, Spinner } from 'react-bootstrap';

export enum ButtonState {
  Primary = 'Primary',
  Loading = 'Loading',
}

interface ButtonProps {
  readonly buttonState: ButtonState;
  readonly onClick: () => void;
  readonly label: string;
  readonly fileName: string;
}

export const Button: React.FC<ButtonProps> = ({
  buttonState,
  onClick,
  fileName,
}) => {
  const isLoading = buttonState === ButtonState.Loading;
  return (
    <a href="javascript: void(0)" onClick={onClick}>
      {isLoading && (
        <div className="d-flex flex-row download-spinner">
          <Spinner
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
            size="sm"
          />
          <p className="download-spinner-text">
            download in progress, please wait
          </p>
        </div>
      )}
      {!isLoading && (
        <i
          className="bi bi-download fs-4"
          aria-label={'download file - ' + fileName}
        ></i>
      )}
    </a>
  );
};
